module.exports = __webpack_public_path__ + "static/img/car.fbe4a45.png";


//////////////////
// WEBPACK FOOTER
// ./src/static_dazzle/images/bgs/car.png
// module id = N1pb
// module chunks = 1